import React from "react";
import ReactDOM from "react-dom";
import {
  Trail,
  Keyframes,
  animated,
  config,
  Transition,
} from "react-spring/renderprops";
import "./App.css";

// words images
import abeja2 from "../../assets/images/words/abeja2.png";
import abuela from "../../assets/images/words/abuela.png";
import balde from "../../assets/images/words/balde.png";
import bolso from "../../assets/images/words/bolso.png";
import botas from "../../assets/images/words/botas.png";
import bote from "../../assets/images/words/bote.png";
import bruja from "../../assets/images/words/bruja.png";
import burro from "../../assets/images/words/burro.png";
import bus from "../../assets/images/words/bus.png";
import escarabajo from "../../assets/images/words/escarabajo.png";
import genio from "../../assets/images/words/genio.png";
import jabalí from "../../assets/images/words/jabalí.png";
import jabón from "../../assets/images/words/jabón.png";
import jardinero from "../../assets/images/words/jardinero.png";
import tiburón from "../../assets/images/words/tiburón.png";
import amasa from "../../assets/images/words/amasa.png";
import ala from "../../assets/images/words/ala.png";
import águila from "../../assets/images/words/águila.png";
import caluga from "../../assets/images/words/caluga.png";
import canguro from "../../assets/images/words/canguro.png";
import fantasma from "../../assets/images/words/fantasma.png";
import fuego from "../../assets/images/words/fuego.png";
import ganso from "../../assets/images/words/ganso.png";
import gata from "../../assets/images/words/gata.png";
import goma from "../../assets/images/words/goma.png";
import gorila from "../../assets/images/words/gorila.png";
import gorro from "../../assets/images/words/gorro.png";
import gota from "../../assets/images/words/gota.png";
import guante from "../../assets/images/words/guante.png";
import gusano from "../../assets/images/words/gusano.png";
import iguana from "../../assets/images/words/iguana.png";
import mago from "../../assets/images/words/mago.png";
import pirata from "../../assets/images/words/pirata.png";
import regalo from "../../assets/images/words/regalo.png";
import arbol from "../../assets/images/words/arbol.png";
import avión from "../../assets/images/words/avión.png";
import apio from "../../assets/images/words/apio.png";
import cama from "../../assets/images/words/cama.png";
import come_torta from "../../assets/images/words/come_torta.png";
import corazón from "../../assets/images/words/corazón.png";
import hombre from "../../assets/images/words/hombre.png";
import lápiz from "../../assets/images/words/lápiz.png";
import lee from "../../assets/images/words/lee.png";
import león from "../../assets/images/words/león.png";
import lila from "../../assets/images/words/lila.png";
import lima from "../../assets/images/words/lima.png";
import limón from "../../assets/images/words/limón.png";
import lobo from "../../assets/images/words/lobo.png";
import loma from "../../assets/images/words/loma.png";
import loro from "../../assets/images/words/loro.png";
import luna from "../../assets/images/words/luna.png";
import mamá from "../../assets/images/words/mamá.png";
import manos from "../../assets/images/words/manos.png";
import melón from "../../assets/images/words/melón.png";
import mesa from "../../assets/images/words/mesa.png";
import mapa from "../../assets/images/words/mapa.png";
import miel from "../../assets/images/words/miel.png";
import mimo from "../../assets/images/words/mimo.png";
import momia from "../../assets/images/words/momia.png";
import mono from "../../assets/images/words/mono.png";
import moto from "../../assets/images/words/moto.png";
import muela from "../../assets/images/words/muela.png";
import mula from "../../assets/images/words/mula.png";
import ola from "../../assets/images/words/ola.png";
import oso from "../../assets/images/words/oso.png";
import patinar from "../../assets/images/words/patinar.png";
import perro from "../../assets/images/words/perro.png";
import piña from "../../assets/images/words/piña.png";
import rosa from "../../assets/images/words/rosa.png";
import sol from "../../assets/images/words/sol.png";
import sala from "../../assets/images/words/sala.png";
import sal from "../../assets/images/words/sal.png";  
import seis from "../../assets/images/words/seis.png";
import suma from "../../assets/images/words/suma.png";  
import tortuga from "../../assets/images/words/tortuga.png";
import isla from "../../assets/images/words/isla.png";
import bicicleta from "../../assets/images/words/bicicleta.png";
import chancho from "../../assets/images/words/chancho.png";
import dado from "../../assets/images/words/dado.png";
import dedo from "../../assets/images/words/dedo.png";
import elefante from "../../assets/images/words/elefante.png";
import erizo from "../../assets/images/words/erizo.png";
import escalera from "../../assets/images/words/escalera.png";
import escoba from "../../assets/images/words/escoba.png";
import lupa from "../../assets/images/words/lupa.png";
import nido from "../../assets/images/words/nido.png";
import nudo from "../../assets/images/words/nudo.png";
import pala from "../../assets/images/words/pala.png";
import pan from "../../assets/images/words/pan.png";
import pera from "../../assets/images/words/pera.png";
import paloma from "../../assets/images/words/paloma.png";
import pipa from "../../assets/images/words/pipa.png";
import puma from "../../assets/images/words/puma.png";
import pulpo from "../../assets/images/words/pulpo.png";
import sombrero from "../../assets/images/words/sombrero.png";
import sopa from "../../assets/images/words/sopa.png";
import guitarra from "../../assets/images/words/guitarra.png";
import papa from "../../assets/images/words/papa.png";
import pila from "../../assets/images/words/pila.png";
import jirafa from "../../assets/images/words/jirafa.png";
import pez from "../../assets/images/words/pez.png";
import torta from "../../assets/images/words/torta.png";
import queque from "../../assets/images/words/queque.png";
import duende from "../../assets/images/words/duende.png";
import maleta from "../../assets/images/words/maleta.png";
import manta from "../../assets/images/words/manta.png";
import nota from "../../assets/images/words/nota.png";
import pasto from "../../assets/images/words/pasto.png";
import patines from "../../assets/images/words/patines.png";
import pato from "../../assets/images/words/pato.png";
import pelota from "../../assets/images/words/pelota.png";
import pepino from "../../assets/images/words/pepino.png";
import pino from "../../assets/images/words/pino.png";
import tapa from "../../assets/images/words/tapa.png";
import tomate from "../../assets/images/words/tomate.png";
import topo from "../../assets/images/words/topo.png";
import tuna from "../../assets/images/words/tuna.png";
import manzana from "../../assets/images/words/manzana.png";
import sapo from "../../assets/images/words/sapo.png";
import abeja from "../../assets/images/words/abeja.png";
import araña from "../../assets/images/words/araña.png";
import ardilla from "../../assets/images/words/ardilla.png";
import calcetín from "../../assets/images/words/calcetín.png";
import camión from "../../assets/images/words/camión.png";
import camisa from "../../assets/images/words/camisa.png";
import caracol from "../../assets/images/words/caracol.png";
import casa from "../../assets/images/words/casa.png";
import corbata from "../../assets/images/words/corbata.png";
import estrella from "../../assets/images/words/estrella.png";
import gato from "../../assets/images/words/gato.png";
import zapatilla from "../../assets/images/words/zapatilla.png";
import campanas from "../../assets/images/words/campanas.png";
import candado from "../../assets/images/words/candado.png";
import carreta from "../../assets/images/words/carreta.png";
import casco from "../../assets/images/words/casco.png";
import coco from "../../assets/images/words/coco.png";
import copa from "../../assets/images/words/copa.png";
import cuento from "../../assets/images/words/cuento.png";
import cuncuna from "../../assets/images/words/cuncuna.png";
import delfín from "../../assets/images/words/delfín.png";
import flores from "../../assets/images/words/flores.png";
import foca from "../../assets/images/words/foca.png";
import mariposa from "../../assets/images/words/mariposa.png";
import pescado from "../../assets/images/words/pescado.png";
import ratón from "../../assets/images/words/ratón.png";
import lápices from "../../assets/images/words/lápices.png";
import piano from "../../assets/images/words/piano.png";
import queso from "../../assets/images/words/queso.png";
import rana from "../../assets/images/words/rana.png";
import raqueta from "../../assets/images/words/raqueta.png";
import remo from "../../assets/images/words/remo.png";
import rinoceronte from "../../assets/images/words/rinoceronte.png";
import dulce from "../../assets/images/words/dulce.png";
import esqueleto from "../../assets/images/words/esqueleto.png";
import falda from "../../assets/images/words/falda.png";
import pimentón from "../../assets/images/words/pimentón.png";
import quitasol from "../../assets/images/words/quitasol.png";
import teléfono from "../../assets/images/words/teléfono.png";
import tigre from "../../assets/images/words/tigre.png";
import torre from "../../assets/images/words/torre.png";
import tres from "../../assets/images/words/tres.png";
import vaca from "../../assets/images/words/vaca.png";
import vestido from "../../assets/images/words/vestido.png";
import volantín from "../../assets/images/words/volantín.png";
import sofá  from "../../assets/images/words/sofá.png";
import guinda  from "../../assets/images/words/guinda.png";
import rama  from "../../assets/images/words/rama.png";
import gallo  from "../../assets/images/words/gallo.png";
import jaula  from "../../assets/images/words/jaula.png";
import oveja  from "../../assets/images/words/oveja.png";


const dict_words = {
  apio: apio,
  guinda: guinda,
  rama: rama,
  gallo: gallo,
  jaula: jaula,
  abeja: abeja2,
  abuela: abuela,
  balde: balde,
  bolso: bolso,
  bote: bote,
  botas: botas,
  bruja: bruja,
  burro: burro,
  bus: bus,
  escarabajo: escarabajo,
  genio: genio,
  jabalí: jabalí,
  jabón: jabón,
  jardinero: jardinero,
  tiburón: tiburón,
  sofá: sofá,
  esqueleto: esqueleto,
  falda: falda,
  pimentón: pimentón,
  quitasol: quitasol,
  teléfono: teléfono,
  tigre: tigre,
  torre: torre,
  tres: tres,
  vaca: vaca,
  vestido: vestido,
  volantín: volantín,
  águila: águila,
  caluga: caluga,
  canguro: canguro,
  fantasma: fantasma,
  ganso: ganso,
  fuego: fuego,
  gata: gata,
  goma: goma,
  gorila: gorila,
  gorro: gorro,
  gota: gota,
  guante: guante,
  gusano: gusano,
  iguana: iguana,
  mago: mago,
  pirata: pirata,
  regalo: regalo,
  remo: remo,
  rana: rana,
  rinoceronte: rinoceronte,
  raqueta: raqueta,
  queso: queso,
  lápices: lápices,
  foca: foca,
  mariposa: mariposa,
  pescado: pescado,
  ratón: ratón,
  paloma: paloma,
  pipa: pipa,
  puma: puma,
  papa: papa,
  piano: piano,
  pila: pila,
  zapatilla: zapatilla,
  mapa: mapa,
  dedo: dedo,
  escalera: escalera,
  escoba: escoba,
  lupa: lupa,
  nido: nido,
  nudo: nudo,
  candado: candado,
  campanas: campanas,
  pan: pan,
  elefante: elefante,
  erizo: erizo,
  amasa: amasa,
  pala: pala,
  pera: pera,
  pulpo: pulpo,
  candado: candado,
  coco: coco,
  copa: copa,
  cuento: cuento,
  sombrero: sombrero,
  sopa: sopa,
  isla: isla,
  ala: ala,
  árbol: arbol,
  avión: avión,
  cuncuna: cuncuna,
  delfín: delfín,
  flores: flores,
  oveja: oveja,
  bicicleta: bicicleta,
  cama: cama,
  chancho: chancho,
  come_torta: come_torta,
  corazón: corazón,
  dado: dado,
  carreta: carreta,
  casco: casco,
  guitarra: guitarra,
  hombre: hombre,
  jirafa: jirafa,
  lápiz: lápiz,
  lee: lee,
  sapo: sapo,
  león: león,
  lila: lila,
  lima: lima,
  limón: limón,
  lobo: lobo,
  loma: loma,
  loro: loro,
  luna: luna,
  mamá: mamá,
  manos: manos,
  manzana: manzana,
  melón: melón,
  mesa: mesa,
  miel: miel,
  mimo: mimo,
  momia: momia,
  mono: mono,
  moto: moto,
  mula: mula,
  muela: muela,
  manta: manta,
  ola: ola,
  oso: oso,
  patinar: patinar,
  perro: perro,
  pez: pez,
  piña: piña,
  rosa: rosa,
  sol: sol,
  seis: seis,
  sal: sal,
  sala: sala,
  suma: suma,
  torta: torta,
  tortuga: tortuga,
  queque: queque,
  rosa: rosa,
  duende: duende,
  dulce: dulce,
  maleta: maleta,
  nota: nota,
  pasto: pasto,
  patines: patines,
  pato: pato,
  pelota: pelota,
  pepino: pepino,
  pino: pino,
  tapa: tapa,
  tomate: tomate,
  topo: topo,
  tuna: tuna,
  abeja: abeja,
  araña: araña,
  ardilla: ardilla,
  calcetín: calcetín,
  camión: camión,
  camisa: camisa,
  caracol: caracol,
  casa: casa,
  corbata: corbata,
  estrella: estrella,
  gato: gato,
};

const defaultStyles = {
  overflow: "hidden",
  position: "absolute",
  color: "black",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // fontSize: "2em",
  fontFamily: "'Kanit', sans-serif",
  textTransform: "uppercase",
  cursor: "pointer",
  zIndex: 1000000,
};

export default class Frame extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      frame: this.props.frame,
      position: this.props.id,
      point: 0,
      imageWord: "",
    };
    this.changeValue = this.changeValue.bind(this);
    this.incrementPoint = this.incrementPoint.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  componentDidUpdate() {
    if (isNaN(this.state.frame)) {
      this.setState({ imageWord: dict_words[this.state.frame] });
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.refresh);
  }

  changeValue(value) {
    this.setState({ frame: value });
  }

  incrementPoint() {
    let point = this.state.frame;
    point = point + 1;
    this.setState({ frame: point });
  }

  refresh() {
    if (typeof this.state.frame === "number") {
      let point = this.state.frame;
      point = point + 1;
      this.setState({ frame: point });
      this.setState({ frame: point - 1 });
    } else {
      let currentFrame = this.state.frame;
      this.setState({ frame: "" });
      this.setState({ frame: currentFrame });
    }
  }

  render() {
    let position = "";
    let width = 9.66;
    let height = (window.innerHeight * 17.4) / 100;
    let top = 0;
    if (
      (window.innerWidth > 480) &
      (window.innerWidth / window.innerHeight > 1)
    ) {
      top = "71.4%";
      position = "33.55%";
      if (this.props.id === 1) {
        position = "45.15%";
      } else if (this.props.id === 2) {
        position = "56.8%";
      } else if (this.props.id === 4) {
        width = 8.35;
        height = (window.innerHeight * 15) / 100;
        position = "72.35%";
        top = "3.9%";
      }
    } else {
      width = 24.5;
      height = (window.innerHeight * 13.5) / 100;
      top = "79.2%";
      position = "10.3%";
      if (this.props.id === 1) {
        position = "39.8%";
      } else if (this.props.id === 2) {
        position = "68.6%";
      } else if (this.props.id === 4) {
        position = "71.9%";
        width = 24.7;
        height = (window.innerHeight * 13.8) / 100;
        top = "3.50%";
      }
    }
    return (
      <Transition
        items={this.state.frame}
        // initial={null}
        from={{
          overflow: "hidden",
          height: height,
          opacity: 1,
          background: "white",
        }}
        enter={{
          width: width + "%",
          height: height,
          opacity: 1,
          borderRadius: "50%",
          border: "3px solid black",
        }}
        leave={{
          height: height,
          opacity: 1,
          display: "none",
        }}
        trail={200}
      >
        {(item) => (styles) => (
          <animated.div
            style={{ ...defaultStyles, ...styles, left: position, top: top }}
          >
            {this.state.imageWord !== "" ? (
              <div>
                <img
                  src={this.state.imageWord}
                  className="words-image"
                  alt="background"
                />
              </div>
            ) : (
              <div>
                <strong style={{ fontSize: "32px" }}>{item}</strong>
              </div>
            )}
          </animated.div>
        )}
      </Transition>
    );
  }
}
